import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { tokens } from '@/theme'
import { CANAL_RECORTE_COR, CANAL_RECORTE_LABEL, CanalDeRecorte } from './canais'

/** Legenda de canais (quadradinho colorido + rótulo) compartilhada pelos gráficos da Visão de Carteira. */
export const LegendaCanais: FC<{ canais: CanalDeRecorte[] }> = ({ canais }) => (
  <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
    {canais.map((c) => (
      <Stack key={c} direction="row" spacing={0.75} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '3px',
            backgroundColor: CANAL_RECORTE_COR[c],
          }}
        />
        <Typography variant="caption" sx={{ color: tokens.textSecondary }}>
          {CANAL_RECORTE_LABEL[c]}
        </Typography>
      </Stack>
    ))}
  </Stack>
)

export default LegendaCanais
